import { createNamespacedHelpers } from '../../../core/services';
import { DAM_SERVICES_NAMESPACE } from '../constants';

const { getService: getDamService, addService: addDamService } = createNamespacedHelpers(
  DAM_SERVICES_NAMESPACE
);

export { getDamService, addDamService };
